import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

import { GenericResponse } from '../../api-interfaces';
import { FuncsService, passwordsDontMatchValidator } from 'src/app/shared/funcs.service'
import { IdentityService } from 'src/app/identity/identity.service';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { LogService } from 'src/app/shared/log.service';
import { User } from 'src/app/identity/user.model';

@Component({
  selector: 'app-password-modify',
  templateUrl: './password-modify.component.html',
  styleUrls: ['./password-modify.component.sass']
})
export class PasswordModifyComponent implements OnInit {

  isSpinning: boolean = false;
  passwordModifyForm!: UntypedFormGroup;
  currentPasswordVisible = false;
  newPasswordVisible = false;
  confirmNewPasswordVisible = false;
  errorMessage: string;
  customError: boolean = false;
  currentUser: User;

  constructor(
    private funcs: FuncsService,
    private fb: UntypedFormBuilder,
    private identityService: IdentityService,
    private router: Router,
    private authService: AuthService,
    private logger: LogService
  ) { }

  ngOnInit(): void {
    this.passwordModifyForm = this.fb.group({
      currentPassword: [null, [Validators.required]],
      newPassword: [null, [Validators.required, Validators.pattern(RegExp(this.funcs.getValidationPattern("password")))]],
      confirmNewPassword: [null, [Validators.required, Validators.pattern(RegExp(this.funcs.getValidationPattern("password")))]],
    }, { validators: passwordsDontMatchValidator });

    this.authService.currentUserChanged.subscribe((data: User) => {
      if (data != null) {

        this.currentUser = data;
        let reg = this.funcs.getValidationPattern("password")
          .replace("STRING1", this.currentUser.first_name.toLowerCase())
          .replace("STRING2", this.currentUser.last_name.toLowerCase())
          .replace("STRING3", this.currentUser.fiscal_code.toLowerCase())
          .replace("STRING4", this.currentUser.identityDocument.document_number.toLowerCase())
          .replace("STRING5", this.currentUser.phone_number.replace("+", ""))
          .replace("STRING6", this.currentUser.birth_date.toString().replace(/\-/gi, "\-"))
          .replace("STRING7", this.currentUser.email.toLowerCase())
          .replace("STRING8", this.currentUser.username.replace(/\./gi, "\."))

        this.passwordModifyForm.controls['newPassword'].setValidators([Validators.required, Validators.pattern(RegExp(reg))])
        this.passwordModifyForm.controls['confirmNewPassword'].setValidators([Validators.required, Validators.pattern(RegExp(reg))])
      }
      else {
        this.passwordModifyForm.addControl('currentUser', new UntypedFormControl(null, Validators.required))
      }
    });
  }

  submitForm(): void {
    for (const i in this.passwordModifyForm.controls) {
      this.passwordModifyForm.controls[i].markAsDirty();
      this.passwordModifyForm.controls[i].updateValueAndValidity();
    }
    let currentUsername = null;
    if (!this.currentUser) {
      currentUsername = this.passwordModifyForm.value["currentUser"];
    }

    let currentPassword: string = this.passwordModifyForm.value["currentPassword"];
    let newPassword: string = this.passwordModifyForm.value["newPassword"];
    let confirmNewPassword: string = this.passwordModifyForm.value["confirmNewPassword"];

    if (!currentPassword || !newPassword || !confirmNewPassword) {
      return;
    }

    this.isSpinning = true;

    this.identityService.changePassword(currentPassword, newPassword, this.currentUser, currentUsername)
      .subscribe(
        (response: GenericResponse) => {
          if (response["esito"] == "OK") {
            this.logger.log("Password cambiata con successo");
            this.authService.logout();
            this.router.navigate(['/']);
          }
        },
        (err: any) => { this.isSpinning = false; },
        () => { this.isSpinning = false; }
      );
  }

  getValidationErrorMessage(errors: any): string {
    return this.funcs.getValidationErrorMessage(errors);
  }
}
